import { getStatusStyles } from "../utils/util";
const ApplicationStatusComponent = ({ application }: any) => (
  // <div className={"w-full h-full bg-red fixed top-0 left-0 flex items-center justify-center"}>
  <div className="flex flex-row items-start justify-start ">
    <div className={`flex-wrap text-wrap p-1 px-2 justify-center flex flex-col items-center rounded-lg relative border-2 border-solid ${getStatusStyles(application.status)} w-full my-0`}>
      {application.autoApproved && <img src={require("../assets/aiLogo.png")} className="w-4 h-4 absolute top-1/2 left-[-8px] -translate-y-1/2" />}
      <span className="text-center text-xs my-0">
        {application.status
          .replaceAll("_", " ")
          .split(" ")
          .map((word: string) =>
            word !== "EMPLOYER" ? word.charAt(0).toUpperCase() + word.slice(1)?.toLowerCase() : ""
          )
          .join(" ")}
      </span>
    </div>
  </div>
  // </div>
);

export default ApplicationStatusComponent;
